// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_3uf18v3Mf4rXzqSHU8VVQ3","checked":"_2a85kuGKMemV-1cMBEuzch","disabled":"PS15f9YboYh_7fxOIqPg1","selected":"_2gXXTXXnd3ejFecSSf5hc3"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/tennis/css/oddsButton.css
// module id = 775
// module chunks = 0